import { useAuth } from "../../../context/AuthProvider";

export const useIsAdmin = () => {
  const { hasRole } = useAuth();           
  return hasRole ("ADMIN") || hasRole ("BUSINESS_OWNER");
};
